import { render, staticRenderFns } from "./TeachingWorkModal.vue?vue&type=template&id=00cf3916&scoped=true"
import script from "./TeachingWorkModal.vue?vue&type=script&lang=js"
export * from "./TeachingWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf3916",
  null
  
)

export default component.exports